import admin from './view';

export default [
  {
    path: '/',
    redirect: 'notice',
  },
  {
    path: 'faq', // FAQ목록
    component: admin('/site/faq'),
  },
  {
    path: 'faq/edit', // FAQ 등록,수정
    component: admin('/site/faqEdit'),
  },
  {
    path: 'faq/:sq', // FAQ상세
    component: admin('/site/faqDetail'),
  },
  {
    path: 'qna', // Q&A목록
    component: admin('/site/qna'),
  },
  {
    path: 'qna/:sq', // Q&A상세
    component: admin('/site/qnaDetail'),
  },
  {
    path: 'popup', // 팝업목록
    component: admin('/site/popup'),
  },
  {
    path: 'popup/:sq', // 팝업상세
    component: admin('/site/popupDetail'),
  },
  {
    path: 'popup/register', // 팝업등록
    component: admin('/site/popupRegister'),
  },
  {
    path: ':type(notice|info)', // 게시판 목록
    component: admin('/site/board'),
  },
  {
    path: ':type(notice|info)/edit', // 게시판 등록,수정
    component: admin('/site/boardEdit'),
  },
  {
    path: ':type(notice|info)/:sq', // 게시판 상세
    component: admin('/site/boardDetail'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/site.js